import { Vector4 } from "three";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import ArrowLineMesh from "../../instancing/Meshes/ArrowLineMesh";
import { sequenceRgbIndex } from "../../constants/sequences";

export function getSequenceMesh(isLeft, floorHeight, isExon) {
  const arrowOffsetAbs = isExon ? 5 : 3;
  const arrowOffset = isLeft ? arrowOffsetAbs : -arrowOffsetAbs;
  const conf = {
    rgbaCode: 1,
    raycastInd: 1,
    posX: 1,
    posY: 1,
  };

  const materialConf = getMaterialWithUniforms({ antialias: true })
    .setOffset([0, 0])
    .setWidth(isExon ? 14 : 8)
    .setArrowPointOffset(arrowOffset)
    .setPaddingX([-1, 1])
    .setPaddingY([0, 0])
    .setColorMap(Array(8).fill(new Vector4()));

  return new ArrowLineMesh(materialConf, conf);
}

export function updateSeqVis(items, mesh) {
  const setY = mesh.updateY({ count: items.length, isAppend: false });
  for (let i = 0; i < items.length; i++) {
    const { level } = items[i].transcript;
    const y = level + 0.5;
    setY(i, y, y, y, y);
  }
}

export function drawSequence(sequences, mesh) {
  const count = sequences.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });

  const setRgbaCode = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const seq = sequences[i];
    const { typeIndex, region } = seq;
    const rgbInd = sequenceRgbIndex[typeIndex];
    const { g0, g1 } = region;
    const s = g0;
    const e = g1;
    setX(i, s, e);
    setRgbaCode(i, rgbInd, rgbInd);
  }
}
